export default {
    menu:[
        
    ],
    fotoPerfil:"/images/usuarioAvatar.png",
    paginaActual:"home",
    showModalAvisoFinSession: false,
     usuarioCombo:[],
    instructores:[],
    preguntasfrecuentes: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    preguntasFrecuentesHome:{},
    insigniaCombo:[],
    homeInfo:{
        imagenes:[{id:1, ruta:'./images/BannerAcademics2.jpg'}]
    },
    insignia: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
cursoGratuitos:[
        {
    id: 6,
      url:"/curso/",   
    image: '/images/premium.jpg',
    imageBg: '/images/premium.jpg',
    title: 'Cursos Premium Belt'
      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

  }
        
    ],
    cursoCarrusel:[],
    ajaxCallsInProgress:0,
    moduloCombo:[],
    roleCombo:[],
    modulo: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":true,		
		"filtroActual":"",
        "showActivos":true,
        filtrosCombo:{
                    curso:"0",
                    opcional:true
            },
	},
    usuario: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    tablas:[],
    cursoCombo:[],
    curso: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    tag: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    strings:{
        "Configuración":"Configuración",
        "Tag":"Tag",
        "nuevo":"nuevo",
        "acciones":"acciones",
        "Curso":"Curso",
        "regresar":"Regresar",
        "guardar":"Guardar",
        "filtroActivo":"filtroActivo",
        "Ingresar":"Ingresar",
        "Salir":"Salir", //Sign out
        "Buscar":"Búscar"//Sign out
    },
    contenido: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
        "filtrosCombo":{
                    curso:"",
                    opcional:true
        },
        "showActivos":true,
	},
    contenidoCombo:[],
    showSidebarIzquierda:false,
    sidebarIzquierda:false,
    user:null,
    tipoContenidoCombo:[],
    tagCombo:[],
    idioma:'es',
    formulario: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
        "showActivos":true
	},
    formularioCombo:[],
    preguntarespuesta: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    preguntarespuestaCombo:[],
    preguntaCombo:[],
    pregunta: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    respuesta: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    respuestaCombo:[],  
    resultadoexamen: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    resultadoexamenCombo:[],
    comentarios: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    comentariosCombo:[],
    cursoaprendizajeCombo:[],
    cursoaprendizaje: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    inscripcion: {
        "modulos":[],
        "inscripcion":[]
    },
        /*{
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
       }
       */
    inscripcionCombo:[],
    cursoopinion: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    cursoopinionCombo:[],
    cursoconstanciaCombo:[],   
    cursoconstancia: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	}, 
    pagos: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    pagosCombo:[],
    referenciabancaria: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    referenciabancariaCombo:[],
    tipomoneda: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    tipomonedaCombo:[],
    cursotipomoneda: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    cursotipomonedaCombo:[],   
    crucigrama: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    crucigramaCombo:[],  
    crucigramapalabras: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    crucigramapalabrasCombo:[],
    usuariocurso: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    usuariocursoCombo:[],
    pagoReporte:[],
    contablecuenta: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    contablecuentaCombo:[],
    contablegasto: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    contablegastoCombo:[],
    contableregistrogasto: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    contableregistrogastoCombo:[],
    pais: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    paisCombo:[],    
    ciudad: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    ciudadCombo:[],
    region: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    regionCombo:[],
    cursoTipoCombo:[],
    descuento: {
		"content":[],
		"paginaActual":0,
		"totalPages":0,
		"registrosPorPagina":12,
		"filtroActivo":false,		
		"filtroActual":"",
       "showActivos":true,
	},
    descuentoCombo:[]
    
    };